module.exports = __webpack_public_path__ + "img/ditu_mobile.281f3692.gif";